import React from "react";
import { Charts } from "./charts/Charts.cmp";
import SpreadsheetTableContainer from "../components/table/SpreadsheetTable";

const ChartsPage = ({ user }) => {
  return (
    <div>
      <h1>Charts</h1>
      <p>Welcome, {user.name}</p>
      {/* <SpreadsheetTableContainer /> */}
      <Charts />
    </div>
  );
};

export default ChartsPage;
